@if (!isLoading) {
  <div class="main-container">
    <div class="main-content">
      <router-outlet></router-outlet>
    </div>
  </div>
} @else {
  <div class="main-container">
    <div class="main-content">
      <div class="loading-wrapper">
        <mat-progress-spinner
          color="primary"
          mode="indeterminate"
          diameter="100">
        </mat-progress-spinner>
      </div>
    </div>
  </div>
}
